import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';

import SuccessIcon from '../assets/images/alert_success_icon.svg';
import ErrorIcon from '../assets/images/alert_error_icon.svg';
import WarningIcon from '../assets/images/alert_warning_icon.svg';
import InfoIcon from '../assets/images/alert_warning_icon.svg';

import CloseSuccessIcon from '../assets/images/close_success.svg';
import CloseErrorIcon from '../assets/images/close_error.svg';
import CloseWarningIcon from '../assets/images/close_warning.svg';
import CloseInfoIcon from '../assets/images/close_warning.svg';

const getSeverityStyles = (severity) => {
  const color = { color: '#383B4F' };
  switch (severity) {
    case 'success':
      return { backgroundColor: '#E1FCE1', color };
    case 'error':
      return { backgroundColor: '#FEEDEE', color };
    case 'warning':
      return { backgroundColor: '#FBF1E0', color };
    case 'info':
      return { backgroundColor: '#FBF1E0', color };
    default:
      return { backgroundColor: '#E0F7FA', color };
  }
};

const getCustomIcon = (severity) => {
  const iconSize = { height: 30, width: 30 };
  switch (severity) {
    case 'success':
      return <img src={SuccessIcon} alt="success" style={iconSize} />;
    case 'error':
      return <img src={ErrorIcon} alt="error" style={iconSize} />;
    case 'warning':
      return <img src={WarningIcon} alt="warning" style={iconSize} />;
    case 'info':
      return <img src={InfoIcon} alt="info" style={iconSize} />;
    default:
      return <img src={InfoIcon} alt="info" style={iconSize} />;
  }
};

const getCloseIcon = (severity, onClose) => {
  const iconSize = { height: 10, width: 10, marginBottom: 5 };
  switch (severity) {
    case 'success':
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <img src={CloseSuccessIcon} alt="close-success" style={iconSize} />
        </IconButton>
      );
    case 'error':
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <img src={CloseErrorIcon} alt="close-error" style={iconSize} />
        </IconButton>
      );
    case 'warning':
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <img src={CloseWarningIcon} alt="close-warning" style={iconSize} />
        </IconButton>
      );
    case 'info':
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <img src={CloseInfoIcon} alt="close-info" style={iconSize} />
        </IconButton>
      );
    default:
      return (
        <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      );
  }
};

const isValidSeverity = (val) => ['success', 'error', 'warning', 'info'].includes(val);

export default function CustomizedSnackbars({ open, message, severity = 'info', onClose }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const normalizedSeverity = isValidSeverity(severity) ? severity : 'info';

  useEffect(() => {
    if (open) {
      setSnackbarOpen(true);
    } else {
      setSnackbarOpen(false);
    }
  }, [open]);

  return (
    <Snackbar
      open={snackbarOpen}
      // autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity={normalizedSeverity}
        variant="filled"
        icon={getCustomIcon(normalizedSeverity)}
        sx={{
          width: '100%',
          ...getSeverityStyles(normalizedSeverity),
          display: 'flex',
          alignItems: 'center',
        }}
        action={getCloseIcon(normalizedSeverity, onClose)}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}